import Login from '@/views/login.vue'
import Shixin from '@/views/shixin.vue'
import Container from '@/views/container.vue'

/*首页*/
import HomeMain from '@/views/home/main.vue'
import HomeMenus from '@/views/home/menus.vue'
import MortgageList from '@/views/home/mortgage-list.vue'
import RedemptionList from '@/views/home/redemption-list.vue'
import TailList from '@/views/home/tail-list.vue'
import EnterpriseList from '@/views/home/enterprise-list.vue'

/* 进件 */
import ReportMain from '@/views/report/index.vue'
import reportView from '@/views/report/view.vue'
import reportOverdue from '@/views/report/overdue.vue'

/*监控*/
import MonitoringIndex from '@/views/monitoring/index.vue'
import MonitoringMenu from '@/views/monitoring/menus.vue'
import Setting from '@/views/setting/index.vue'
import allList from '@/views/monitoring/module/all-list.vue'
import auditList from '@/views/monitoring/module/audit-list.vue'
import inLoanList from '@/views/monitoring/module/inloan-list.vue'
import clearList from '@/views/monitoring/module/clear-list.vue'
import failList from '@/views/monitoring/module/fail-list.vue'
import breakList from '@/views/monitoring/module/break-list.vue'

import House from '@/views/home/house/index.vue'
import Application from '@/views/home/business/application.vue'
import ForeclosureInfo from '@/views/home/business/foreclosure/foreclosure-info.vue'
import TailInfo from '@/views/home/business/tail/tail-info.vue'
import MortgageInfo from '@/views/home/business/mortgage/mortgage-info.vue'
import tabBar from '@/components/Tabbar/index.vue'

export default [
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/overdue',
        name: 'overdue',
        component: reportOverdue
    },
    {
        path: '/shixin',
        name: 'shixin',
        component: Shixin
    },
    {
        path: '/',
        name: 'container_main',
        component: Container,
        redirect: '/login',
        children: [
            {
                path: 'home',
                name: 'home_menu',
                components: {
                    default: HomeMenus,
                    tabBar: tabBar
                }
            },
            {
                path: 'home/mortgage-list',
                name: 'mortgage-list',
                components: {
                    default: MortgageList
                }
            },
            {
                path: 'home/redemption-list',
                name: 'redemption-list',
                components: {
                    default: RedemptionList
                }
            },
            {
                path: 'home/enterprise-list',
                name: 'enterprise-list',
                components: {
                    default: EnterpriseList
                }
            },{
                path: 'home/tail-list',
                name: 'tail-list',
                components: {
                    default: TailList
                }
            },  {
                path: '/foreclosure/:id',
                name: 'foreclosureInfo',
                components: {
                    default: ForeclosureInfo
                }
            }, {
                path: '/tail/:id',
                name: 'tailInfo',
                components: {
                    default: TailInfo
                }
            }, {
                path: '/mortgage/:id',
                name: 'mortgageInfo',
                components: {
                    default: MortgageInfo
                }
            },
            {
                path: '/monitoring',
                name: 'monitoring_main',
                redirect: '/monitoring/menus',
                components: {
                    default: MonitoringIndex,
                    tabBar: tabBar
                },
                children: [
                    {
                        path: 'menus',
                        name: 'monitoring_menu',
                        components: {
                            monitoring: MonitoringMenu
                        }
                    },
                    {
                        path: 'all-list',
                        name: 'all-list',
                        components: {
                            monitoring: allList
                        }
                    }, {
                        path: 'audit-list',
                        name: 'audit-list',
                        components: {
                            monitoring: auditList
                        }
                    }, {
                        path: 'inLoan-list',
                        name: 'inLoan-list',
                        components: {
                            monitoring: inLoanList
                        }
                    }, {
                        path: 'clear-list',
                        name: 'clear-list',
                        components: {
                            monitoring: clearList
                        }
                    }, {
                        path: 'fail-list',
                        name: 'fail-list',
                        components: {
                            monitoring: failList
                        }
                    }, {
                        path: 'break-list',
                        name: 'break-list',
                        components: {
                            monitoring: breakList
                        }
                    }
                ]
            },
            {
                path: '/report',
                name: 'report_main',
                redirect: '/report/overdue',
                components: {
                    default: ReportMain,
                    tabBar: tabBar
                },
                children: [
                    {
                        path: 'view',
                        name: 'report_view',
                        components: {
                            applyRouter: reportView
                        }
                    }
                ]
            },
            {
                path: '/setting',
                name: 'setting_main',
                components: {
                    default: Setting,
                    tabBar: tabBar
                }
            },
            {
                path: 'house',
                name: 'house_index',
                components: {
                    default: House,
                    /*tabBar: customerTabBar*/
                }
            },
            {
                path: 'application',
                name: 'application',
                components: {
                    default: Application,
                    /*tabBar: customerTabBar*/
                }
            }
        ]
    }
]
